import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import { PaymentLinkItem } from 'payment-link-components/components/PaymentLinkSelect';
// @ts-expect-error no types
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentLinkItemWrapper = styled.div.withConfig({
  displayName: "WrappedPaymentLinkItem__PaymentLinkItemWrapper",
  componentId: "sc-610yqn-0"
})(["cursor:pointer;"]);
function isPayment(option) {
  return option.id !== undefined;
}
const WrappedPaymentLinkItem = _ref => {
  let {
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (isPayment(option)) {
    return /*#__PURE__*/_jsx(PaymentLinkItemWrapper, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(PaymentLinkItem, {
        paymentLink: option
      })
    }));
  } else {
    return /*#__PURE__*/_jsx(UITypeaheadResultsItem, Object.assign({
      disabled: option.disabled,
      option: option
    }, rest));
  }
};
export default WrappedPaymentLinkItem;